import { Skeleton } from './Skeleton';

export function PageLoader() {
  return (
    <div className="flex-1 flex flex-col gap-6 p-6 md:p-8 animate-in fade-in duration-500">
      {/* Page Header Skeleton */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="flex flex-col gap-2 w-full max-w-xs">
          <Skeleton className="h-8 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
        <div className="flex gap-3 w-full sm:w-auto">
          <Skeleton className="h-10 w-24" />
          <Skeleton className="h-10 w-32" />
        </div>
      </div>

      {/* Main Content Area Skeleton */}
      <div className="flex flex-col gap-6 mt-4">
        {/* Top metrics/cards row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <Skeleton className="h-28 rounded-md" />
          <Skeleton className="h-28 rounded-md" />
          <Skeleton className="h-28 rounded-md" />
          <Skeleton className="h-28 rounded-md" />
        </div>

        {/* Data table/list area */}
        <div className="border border-border rounded-lg bg-surface-1 overflow-hidden">
          <div className="p-4 border-b border-border flex justify-between">
             <Skeleton className="h-6 w-48" />
             <Skeleton className="h-8 w-64" />
          </div>
          <div className="p-4">
             <Skeleton rows={6} />
          </div>
        </div>
      </div>
    </div>
  );
}
